var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-input',{staticClass:"input-group",attrs:{"wrapperClass":"address","label":_vm.label,"placeholder":_vm.placeholder,"type":"text","value":_vm.address,"id":_vm.id,"full-width":""}})}
var staticRenderFns = []

export { render, staticRenderFns }